import type { Styles } from 'src/theme/themes';

export const styles = {
  pill: (theme) => ({
    display: 'flex',
    padding: `${theme.spacing(0.25)} ${theme.spacing(0.5)}`,
    gap: 0.25,
    alignItems: 'center',
    width: 'max-content',
  }),
} satisfies Styles;
